module.exports = __webpack_public_path__ + "media/images/athletes/1644-9f5ce48781e007db48b92b9b174e6137.png";